import React, { useEffect, useState } from "react";
import Button from "../SelectValue/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import getServices from "../../Services/get-service";
import swal from "sweetalert";
import {
  Checkbox,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import more from "../../Assets/images/more.svg";
import Loading from "../SelectValue/Loading";
import Constant from "../../Constant";
import TopDCom from "./TopDCom";
import MUIButton from "@mui/material/Button";
import { getApiErrorMessage } from "../../utils/apiError";

export default function SavingsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [savingsCategory, setSavingsCategory] = useState([]);
  const [allSavingsCategory, setAllSavingsCategory] = useState([]);
  const [planType, setPlanType] = useState("");
  const [savingsType, setSavingsType] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const [fromDate, setFromDate] = useState(oneWeekAgo);
  const [toDate, setToDate] = useState(currentDate);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSavingId, setSelectedSavingId] = useState(null);

  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [historyPagination, setHistoryPagination] = useState(null);
  const [historyPage, setHistoryPage] = useState(0);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [historyFilter, setHistoryFilter] = useState("all"); // 'all', 'inflow', 'outflow'

  const [totalActiveSavingPlan, setTotalActiveSavingsPlan] = useState("0");
  const [totalAmountSaved, setTotalAmountSaved] = useState("0");
  const [numberOfUsersSaving, setNumberOfUsersSaving] = useState("0");

  const closeHistoryModal = () => {
    setHistoryModalOpen(false);
    setTransactionHistory([]);
    setHistoryPage(0);
    setHistoryPagination(null);
    setHistoryFilter("all");
  };

  const openHistoryModal = (savingsId) => {
    setHistoryModalOpen(true);
    setLoadingHistory(true);
    setSelectedSavingId(savingsId);

    getServices.getSavingsHistory(savingsId, 0, 10).then(
      (response) => {
        setLoadingHistory(false);
        if (response.data.status === "2000") {
          setTransactionHistory(response.data.data.history || []);
          setHistoryPagination(response.data.data.pagination);
        } else {
          swal("Failed to load transaction history");
          closeHistoryModal();
        }
      },
      (error) => {
        setLoadingHistory(false);
        console.error(error);
        swal(getApiErrorMessage(error, "Error loading transaction history"));
        closeHistoryModal();
      },
    );
  };

  const handleHistoryPreviousPage = () => {
    if (historyPagination && !historyPagination.isFirst && selectedSavingId) {
      const newPage = historyPage - 1;
      setHistoryPage(newPage);
      setLoadingHistory(true);

      getServices.getSavingsHistory(selectedSavingId, newPage, 10).then(
        (response) => {
          setLoadingHistory(false);
          if (response.data.status === "2000") {
            setTransactionHistory(response.data.data.history || []);
            setHistoryPagination(response.data.data.pagination);
          }
        },
        (error) => {
          setLoadingHistory(false);
          console.error(error);
        },
      );
    }
  };

  const handleHistoryNextPage = () => {
    if (historyPagination && !historyPagination.isLast && selectedSavingId) {
      const newPage = historyPage + 1;
      setHistoryPage(newPage);
      setLoadingHistory(true);

      getServices.getSavingsHistory(selectedSavingId, newPage, 10).then(
        (response) => {
          setLoadingHistory(false);
          if (response.data.status === "2000") {
            setTransactionHistory(response.data.data.history || []);
            setHistoryPagination(response.data.data.pagination);
          }
        },
        (error) => {
          setLoadingHistory(false);
          console.error(error);
        },
      );
    }
  };

  // Filter transaction history based on selected filter
  const filteredTransactionHistory = transactionHistory.filter(
    (transaction) => {
      if (historyFilter === "all") return true;
      if (historyFilter === "inflow") return transaction.type === "CREDIT";
      if (historyFilter === "outflow") return transaction.type === "DEBIT";
      return true;
    },
  );

  useEffect(() => {
    const params = {};

    if (planType) {
      params.planType = planType;
    }

    if (savingsType) {
      params.savingsType = savingsType;
    }

    getServices.getSavingsStats(params).then(
      (response) => {
        if (response.data.status === "2000") {
          const stats = response.data.data || {};
          setNumberOfUsersSaving(
            stats.numberOfUsersSaving ??
              stats.noOfSavings ??
              stats.usersSaving ??
              stats.totalUsers ??
              0,
          );
          setTotalActiveSavingsPlan(
            stats.totalActiveSavings ??
              stats.totalActiveSavingPlan ??
              stats.activeSavingsPlans ??
              stats.totalSavingsPlans ??
              0,
          );
          setTotalAmountSaved(
            stats.totalAmountSaved ??
              stats.totalSaved ??
              stats.amountSaved ??
              0,
          );
        }
      },
      (error) => {},
    );
  }, [planType, savingsType]);

  useEffect(() => {
    setLoading(true);

    const params = {
      page: page,
      limit: rowsPerPage,
    };

    if (planType) {
      params.type = planType;
    }

    if (status) {
      params.status = status;
    }

    if (searchTerm.trim()) {
      params.q = searchTerm.trim();
    }

    if (category) {
      const selectedCategory = savingsCategory.find(
        (cat) => cat.name === category,
      );
      if (selectedCategory && selectedCategory.id) {
        params.categoryId = selectedCategory.id;
      }
    }

    getServices.getSavingsByPlanType(params).then(
      (response) => {
        setLoading(false);
        if (response.data.status === "2000") {
          // Sort in descending order by createdDate
          const sortedSavings = (response.data.data.savings || []).sort(
            (a, b) => {
              return new Date(b.createdDate) - new Date(a.createdDate);
            },
          );
          setSaving(sortedSavings);
          setPagination(response.data.data.pagination);
        }
      },
      (error) => {
        setLoading(false);
        console.log(error);
        swal(getApiErrorMessage(error, "Error loading savings"));
      },
    );
  }, [page, rowsPerPage, planType, category, status, savingsCategory, searchTerm]);

  const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  };

  useEffect(() => {
    setLoading(true);
    getServices.getSavingsCategory().then(
      (response) => {
        setLoading(false);
        if (response.data.status === "2000") {
          setAllSavingsCategory(response.data.data);
          setSavingsCategory(response.data.data);
        } else {
          swal(response.data.description);
        }
      },
      (error) => {
        setLoading(false);
        console.error(error);
        swal(getApiErrorMessage(error, "Error loading savings categories"));
      },
    );
  }, []);

  useEffect(() => {
    if (planType) {
      const filtered = allSavingsCategory.filter(
        (cat) => cat.planType === planType,
      );
      setSavingsCategory(filtered);
      setCategory("");
      setPage(0);
    } else {
      setSavingsCategory(allSavingsCategory);
      setCategory("");
    }
  }, [planType, allSavingsCategory]);

  const handleOpenMenu = (event, savingId) => {
    setAnchorEl(event.currentTarget);
    setSelectedSavingId(savingId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const viewTransactionHistory = (savingId) => {
    setSelectedSavingId(savingId);
    openHistoryModal(savingId);
    handleCloseMenu();
  };

  const handlePreviousPage = () => {
    if (pagination && !pagination.isFirst) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (pagination && !pagination.isLast) {
      setPage(page + 1);
    }
  };

  const filteredSavings = saving;

  const totalPages = pagination ? pagination.totalPages : 1;

  return (
    <>
      <Loading open={loading} />

      <Dialog
        open={historyModalOpen}
        onClose={closeHistoryModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle className="border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold text-gray-800">
              Transactions
            </h2>
            <div className="flex gap-2"></div>
          </div>
        </DialogTitle>
        <DialogContent className="p-0">
          {loadingHistory ? (
            <div className="flex justify-center items-center py-12">
              <CircularProgress />
            </div>
          ) : filteredTransactionHistory.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              No transaction history found.
            </div>
          ) : (
            <div className="divide-y">
              {filteredTransactionHistory.map((transaction, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-4 flex-1">
                    <div
                      className={` rounded-full flex items-center justify-center`}
                    >
                      <span
                        className={`text-xl font-bold ${
                          transaction.type === "CREDIT"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      ></span>
                    </div>

                    <div className="flex-1">
                      <p className="font-semibold text-gray-900 capitalize">
                        {transaction.type === "CREDIT" ? "Credit" : "Debit"}
                      </p>
                      <p className="text-sm text-gray-500">
                        {transaction.source}
                      </p>
                      <p className="text-sm text-gray-500">
                      {new Date(transaction.createdAt).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        },
                      )}
                    </p>
                    </div>
                  </div>

                  <div className="text-right">
                    <p
                      className={`font-bold text-lg ${
                        transaction.type === "CREDIT"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      ₦{Constant.FormatNumber(transaction.amount)}
                    </p>
                    
                  </div>
                </div>
              ))}

              {historyPagination && historyPagination.totalPages > 1 && (
                <div className="flex justify-center items-center gap-2 py-6 px-6 bg-gray-50">
                  <button
                    onClick={handleHistoryPreviousPage}
                    disabled={historyPagination.isFirst}
                    className={`px-4 py-2 text-sm ${
                      historyPagination.isFirst
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-gray-700 hover:bg-gray-200"
                    } rounded`}
                  >
                    prev
                  </button>

                  {[...Array(historyPagination.totalPages)].map((_, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        setHistoryPage(i);
                        setLoadingHistory(true);
                        getServices
                          .getSavingsHistory(selectedSavingId, i, 10)
                          .then(
                            (response) => {
                              setLoadingHistory(false);
                              if (response.data.status === "2000") {
                                setTransactionHistory(
                                  response.data.data.history || [],
                                );
                                setHistoryPagination(
                                  response.data.data.pagination,
                                );
                              }
                            },
                            (error) => {
                              setLoadingHistory(false);
                              console.error(error);
                            },
                          );
                      }}
                      className={`w-8 h-8 rounded ${
                        historyPagination.currentPage === i
                          ? "bg-purple-600 text-white"
                          : "text-gray-700 hover:bg-gray-200"
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    onClick={handleHistoryNextPage}
                    disabled={historyPagination.isLast}
                    className={`px-4 py-2 text-sm ${
                      historyPagination.isLast
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-gray-700 hover:bg-gray-200"
                    } rounded`}
                  >
                    next
                  </button>
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions className="border-t p-4">
          <MUIButton onClick={closeHistoryModal} sx={{ color: "#7C3AED" }}>
            Close
          </MUIButton>
        </DialogActions>
      </Dialog>

      <div className="my-8 flex flex-wrap items-center gap-4">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-9 gap-4">
          <div className="w-full sm:w-auto lg:col-span-3">
            <input
              placeholder="Search by name or email address"
              className="border border-gray-300 focus:border-primary-color outline-none p-2 rounded w-full"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(0);
              }}
            />
          </div>

          <div className="w-full sm:w-auto">
            <select
              value={planType}
              onChange={(e) => {
                setPlanType(e.target.value);
                setPage(0);
              }}
              className="border w-full p-3 rounded"
            >
              <option value="">Select Plan Type</option>
              <option value="ADMIN_GOAL">Admin Goal</option>
              <option value="TEMPLATE">Template</option>
            </select>
          </div>

          <div className="w-full sm:w-auto">
            <select
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
                setPage(0);
              }}
              className="border w-full p-3 rounded"
              disabled={!planType}
            >
              <option value="">Select Savings Category</option>
              {savingsCategory.map((e, i) => (
                <option key={i} value={e.name}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full sm:w-auto">
            <select
              value={savingsType}
              onChange={(e) => {
                setSavingsType(e.target.value);
                setPage(0);
              }}
              className="border w-full p-3 rounded"
            >
              <option value="">Select Savings Type</option>
              <option value="FLEX_TIME">Flex Time</option>
              <option value="FLEX_AMOUNT">Flex Amount</option>
              <option value="STASH">Stash</option>
            </select>
          </div>

          <div className="w-full sm:w-auto">
            <select
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                setPage(0);
              }}
              className="border w-full p-3 rounded"
            >
              <option value="">Select Status</option>
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
              {/* <option value="COMPLETED">Completed</option> */}
            </select>
          </div>

          <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">From:</p>
            <DatePicker
              className="w-full p-2 bg-white border border-gray-300 outline-0 rounded"
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
          <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">To:</p>
            <DatePicker
              className="w-full p-2 bg-white border border-gray-300 outline-0 rounded"
              selected={toDate}
              onChange={(date) => setToDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-5 gap-4">
        <TopDCom
          name="Plan Type"
          count={
            planType
              ? planType === "ADMIN_GOAL"
                ? "Admin Goal"
                : "Template"
              : "All"
          }
        />
        <TopDCom
          name="Savings Type"
          count={
            savingsType
              ? savingsType === "FLEX_TIME"
                ? "Flex Time"
                : savingsType === "FLEX_AMOUNT"
                  ? "Flex Amount"
                  : "Stash"
              : "All"
          }
        />
        <TopDCom
          name="Total amount saved"
          count={totalAmountSaved === "nu" ? "0" : totalAmountSaved}
        />
        <TopDCom
          name="Total active savings plans"
          count={totalActiveSavingPlan === "nu" ? "0" : totalActiveSavingPlan}
        />
        <TopDCom
          name="Number of users saving"
          count={numberOfUsersSaving === "nu" ? "0" : numberOfUsersSaving}
        />
      </div>

      <div className="mt-16">
        <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
          <Checkbox />
          <p className="text-text flex-1 text-center whitespace-normal break-anywhere">
            User
          </p>
          <p className="text-text flex-1 text-center whitespace-normal break-anywhere">
            Date Created
          </p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">
            Maturity Date
          </p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">
            Savings Balance
          </p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">
            Status
          </p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">
            Action
          </p>
        </div>

        {loading ? (
          <div>
            {[...Array(rowsPerPage)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
              >
                <div className="w-6 md:w-[5%]">
                  <Skeleton width={24} height={24} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="80%" height={20} />
                  <Skeleton width="60%" height={16} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width={24} height={24} className="mx-auto" />
                </div>
              </div>
            ))}
          </div>
        ) : filteredSavings.length === 0 ? (
          <div className="text-center p-4 text-gray-500">
            No active saving found.
          </div>
        ) : (
          <>
            <div className="md:hidden">
              {filteredSavings.map((row, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
                >
                  <p className="font-semibold capitalize">
                    {row.firstName} {row.lastName}
                    <span className="text-[#5C556C]">{row.email}</span>
                  </p>
                  <p>
                    <b>Date Created:</b>{" "}
                    {row.createdDate?.slice(0, 10) ?? "No date"}
                  </p>
                  <p>
                    <b>Maturity Date:</b> {row.maturityDate ?? "No date"}
                  </p>
                  <p>
                    <b>Savings Balance:</b> NGN{" "}
                    {Constant.FormatNumber(row.balance)}
                  </p>
                  <p>
                    <b>Status:</b>{" "}
                    <span
                      className={
                        row.status === "ACTIVE"
                          ? "text-green-700"
                          : "text-red-600"
                      }
                    >
                      {row.status}
                    </span>
                  </p>
                  <div className="flex justify-end mt-2">
                    <img
                      src={more}
                      alt="More options"
                      className="cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, row.savingsId)}
                    />
                  </div>
                  <Menu
                    anchorEl={anchorEl}
                    open={
                      Boolean(anchorEl) && selectedSavingId === row.savingsId
                    }
                    onClose={handleCloseMenu}
                    sx={{ "& .MuiPaper-root": { boxShadow: "none" } }}
                  >
                    <MenuItem
                      onClick={() => viewTransactionHistory(row.savingsId)}
                    >
                      Transaction History
                    </MenuItem>
                  </Menu>
                </div>
              ))}
            </div>

            <div className="hidden md:block">
              {filteredSavings.map((row, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
                >
                  <Checkbox />
                  <div className="flex-1 text-center capitalize break-words whitespace-normal min-w-0 px-1">
                    {row.firstName} {row.lastName}
                    <p className="text-sm text-[#5C556C]">{row.email}</p>
                  </div>
                  <p className="flex-1 text-center">
                    {row.createdDate?.slice(0, 10) ?? "No date"}
                  </p>
                  <p className="flex-1 text-center">
                    {row.maturityDate ?? "No date"}
                  </p>
                  <p className="flex-1 text-center ">
                    NGN {Constant.FormatNumber(row.balance)}
                  </p>
                  <p className="flex-1 text-center">
                    <span
                      className={
                        row.status === "ACTIVE"
                          ? "text-green-700"
                          : "text-red-600"
                      }
                    >
                      {row.status}
                    </span>
                  </p>
                  <div className="flex-1 text-center">
                    <img
                      src={more}
                      alt="More options"
                      className="mx-auto cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, row.savingsId)}
                    />
                    <Menu
                      anchorEl={anchorEl}
                      open={
                        Boolean(anchorEl) && selectedSavingId === row.savingsId
                      }
                      onClose={handleCloseMenu}
                      sx={{ "& .MuiPaper-root": { boxShadow: "none" } }}
                    >
                      <MenuItem
                        onClick={() => viewTransactionHistory(row.savingsId)}
                      >
                        Transaction History
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {totalPages > 1 && (
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 mb-10">
            <button
              onClick={handlePreviousPage}
              disabled={!pagination || pagination.isFirst}
              className={`px-4 py-2 rounded-lg ${
                !pagination || pagination.isFirst
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-primary-color text-white hover:bg-primary-color-dark"
              }`}
            >
              Previous
            </button>
            <p className="text-text text-sm sm:text-base">
              Page {pagination ? pagination.currentPage + 1 : 1} of {totalPages}
              {/* {pagination && ` (${pagination.totalItems} total items)`} */}
            </p>
            <button
              onClick={handleNextPage}
              disabled={!pagination || pagination.isLast}
              className={`px-4 py-2 rounded-lg ${
                !pagination || pagination.isLast
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-primary-color text-white hover:bg-primary-color-dark"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
}
